import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { StatusFilterContainer, FilterChip } from './StatusFilter.styles';

const StatusFilter = ({ selectedFilter, onFilterChange, statusCounts = {} }) => {
    const getFilterCount = (filterKey) => {
        if (filterKey === 'all') {
            return Object.values(statusCounts).reduce((sum, count) => sum + count, 0);
        }
        return statusCounts[filterKey] || 0;
    };

    return (
        <StatusFilterContainer>
            <Typography variant="h6GrayUppercase" sx={{ mb: 1 }}>
                Filter by Status
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {STATUS_FILTERS.map((filter) => {
                    const count = getFilterCount(filter.key);
                    const isSelected = selectedFilter === filter.key;

                    return (
                        <FilterChip
                            key={filter.key}
                            label={`${filter.label} (${count})`}
                            color={filter.color}
                            variant={isSelected ? 'filled' : 'outlined'}
                            selected={isSelected}
                            onClick={() => onFilterChange(filter.key)}
                            size="small"
                            sx={filter.key === 'break-overdue' ? {
                                borderColor: '#FF9500',
                                color: '#FF9500',
                                '&.MuiChip-filled': {
                                    backgroundColor: '#FF9500',
                                    color: '#FFFFFF',
                                }
                            } : filter.key === 'upcoming' ? {
                                borderColor: '#64D2FF',
                                color: '#64D2FF',
                                '&.MuiChip-filled': {
                                    backgroundColor: '#64D2FF',
                                    color: '#FFFFFF',
                                }
                            } : {}}
                        />
                    );
                })}
            </Box>
        </StatusFilterContainer>
    );
};

const STATUS_FILTERS = [
    { key: 'all', label: 'All', color: 'default' },
    { key: 'clocked-in', label: 'Working', color: 'success' },
    { key: 'break-completed', label: 'Break Completed', color: 'success' },
    { key: 'on-break', label: 'On Break', color: 'info' },
    { key: 'break-due', label: 'Break Due', color: 'warning' },
    { key: 'break-overdue', label: 'Break Overdue', color: 'default' },
    { key: 'late', label: 'Late', color: 'error' },
    { key: 'upcoming', label: 'Upcoming', color: 'default' },
    { key: 'missed', label: 'Missed', color: 'error' },
    { key: 'clocked-out', label: 'Off Duty', color: 'default' }
];

StatusFilter.propTypes = {
    selectedFilter: PropTypes.string.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    statusCounts: PropTypes.object
};

export default StatusFilter;
